<script>
  import { deleteQueryStringParameter } from "../url";
  import {Accordion} from "sveltestrap";

  let statusMessage = "";
</script>

<!-- Sidebar -->
<div class="sidebar h-100">
  <aside class="p-3">
    <h2>Search Options</h2>
    <p class="lead">Use the following search options to narrow down your results.</p>
    <ul class="list-unstyled">
      <slot name="name"></slot>

      <!--  divider -->
      <li>
        <div class="my-4"></div>
      </li>

      <!-- Datatype Search -->
      <slot name="datatypes"></slot>

      <!--  divider -->
      <li>
        <div class="my-3"></div>
      </li>

      <!-- When -->
      <slot name="when"></slot>

      <!--  divider -->
      <li>
        <div class="my-4"></div>
      </li>

      <!-- Where -->
      <slot name="where"></slot>

      <!--  divider -->
      <li>
        <div class="my-4"></div>
      </li>

      <!--  divider -->
      <li>
        <div class="my-4"></div>
      </li>

      <!-- Access Level -->
      <slot name="accessLevel"></slot>

      <!--  divider -->
      <li>
        <div class="my-4"></div>
      </li>

      <!-- Formats -->
      <slot name="formats"></slot>

      <!--  divider -->
      <li>
        <div class="my-3"></div>
      </li>

      <!-- Station Search -->
      <slot name="stations"></slot>
      <slot name="button"></slot>

      <!--  divider -->
      <li>
        <div class="my-3"></div>
      </li>

      <!-- Weather Flags Search -->
      <slot name="weatherFlags"></slot>

      <!--  divider -->
      <li>
        <div class="my-3"></div>
      </li>

      <!-- Channel Search -->
      <slot name="channels"></slot>

      <!--  divider -->
      <li>
        <div class="my-3"></div>
      </li>

      <!-- advanced user -->
      <slot name="advancedOptions"></slot>
    </ul>

    <div class="d-grid gap-2">
      <button
        type="button"
        id="clearSearch"
        class="btn ae-outline-primary"
        on:click={() => deleteQueryStringParameter()}
        on:click={() => (statusMessage = "All search fields have been cleared.")}
      >
        Clear All Searches
      </button>
    </div>

    <!-- ARIA live region for status messages -->
    <div aria-live="polite" aria-atomic="true" class="visually-hidden">
      {statusMessage}
    </div>
  </aside>
</div>

<style>
  .sidebar {
    min-height: 780px;
  }
</style>
